import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-appointer-popup',
  templateUrl: './add-appointer-popup.component.html',
  styleUrls: ['./add-appointer-popup.component.css']
})
export class AddAppointerPopupComponent implements OnInit {
  @Input() selectedAppointmentWith;
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  closePopup(action){
    this.activeModal.close(action);
  }
}
